module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h2', [_vm._v("Resultat av jämförelse")]), _vm._v(" "), _c('div', {
    staticClass: "contain-rows"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "first-entry"
  }), _vm._v(" "), _vm._l((_vm.companies), function(company, index) {
    return (_vm.chosen.includes(company.name)) ? [(index !== _vm.companies.length) ? _c('div', {
      staticClass: "space"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "images"
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])])] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "highest"
  }, [_vm._v("\n            " + _vm._s(_vm._f("normalize")(_vm.highestPrice)) + " kr/liter\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "lowest"
  }, [_vm._v("\n            " + _vm._s(_vm._f("normalize")(_vm.lowestPrice)) + " kr/liter\n          ")])]), _vm._v(" "), _vm._l((_vm.companies), function(company, index) {
    return (_vm.chosen.includes(company.name)) ? [_c('div', {
      staticClass: "space"
    }, _vm._l((5), function(n) {
      return _c('div', {
        staticClass: "space-line"
      })
    })), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "chart-column-container"
    }, [_c('div', {
      directives: [{
        name: "scroll",
        rawName: "v-scroll",
        value: ({
          name: company.name
        }),
        expression: "{ name: company.name }"
      }],
      staticClass: "chart-fill",
      style: ({
        background: company.name !== 'Tanka' ? '#75a3b1' : ''
      }),
      attrs: {
        "id": company.name
      }
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n                  " + _vm._s(_vm.lowValue) + "\n                ")])])])])] : _vm._e()
  })], 2), _vm._v(" "), (_vm.target) ? _c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.scrollDown
    }
  }, [_vm._v("Årlig besparing")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbd34ba2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/result.vue
// module id = 288
// module chunks = 1